import iconTemplate from '~/components/icons/IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Align-Right--Streamline-Flex"
    >
        <desc>
            {'\n    Align Right Streamline Icon: https://streamlinehq.com\n  '}
        </desc>
        <g id="align-right--rag-paragraph-text-alignment-align-right-formatting-left">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 0.5H0.5"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 4.8335H4.25"
                strokeWidth={1}
            />
            <path
                id="Vector_3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 13.5H0.5"
                strokeWidth={1}
            />
            <path
                id="Vector_4"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 9.1665H4.25"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
